import React, { useState } from 'react';
import { AppBar, Container, createTheme, CssBaseline, Drawer, IconButton, List, ListItemButton, ListItemText, ThemeProvider, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Ajot from './components/Ajot';
import Kirjaa from './components/Kirjaa';
import Asetukset from './components/Asetukset';
import Tilastot from './components/Tilastot';
import Tutorial from "./components/Tutorial"; // 🔹 TUO TUTORIAL-KOMPONENTTI
import Ohjeet from './components/Ohjeet';
import pkg from '../package.json';

const App: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string>("");
  const [kayttajaId, setKayttajaId] = useState<number>(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [suurinJarjestysNum, setSuurinJarjestysNum] = useState<number>(0);
  const [startTutorial, setStartTutorial] = useState(false); // 🔹 TUTORIAL-TILA


  const theme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  const handleLogout = () => {
    //localStorage.removeItem('token');
    setToken("");
    navigate("/login");

  };

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };


  const startOpas = () => {
    setStartTutorial(true);
  };


  const menuItems = [
    { text: 'Selaa kirjaa', path: '/' },
    { text: 'Lisää uusi työvuoro', path: '/kirjaa' },
    { text: 'Asetukset', path: '/asetukset' },
    { text: 'Tilastot', path: '/tilastot' },
    { text: 'Ohjeet', path: '/ohjeet' },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <img
              src="/favicon.ico"
              alt="favicon"
              style={{
                width: 40,
                height: 40,
                marginRight: 10,
              }}
            />
            Vek e-Kirja
          </Typography>
          <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List onKeyDown={toggleDrawer(false)}>

          {menuItems.map((item, index) => (
            <ListItemButton key={index} component={Link} to={item.path} id="uusi-tyovuoro" onClick={toggleDrawer(false)}>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
          {token && (
            <ListItemButton onClick={() => {
              handleLogout();
              setDrawerOpen(false); // Sulje valikko vain tässä
            }}>
              <ListItemText primary="Kirjaudu ulos" />
            </ListItemButton>
          )}


        </List>

        <Typography
          variant="body2"
          color="textSecondary"
          align="right"
          sx={{
            position: 'absolute',
            bottom: 16,
            left: 0,
            right: 0,
            padding: 2,
          }}
        >
          Vek e-Kirja <br />
          Versio {pkg.version} <br />
          © 2025 H. Sallila <br />
          <br />
          <i>Aikataulutiedot perustuvat Fintrafficin Digitraffic-palvelun avoimeen dataan. Lisenssi: CC 4.0 BY.</i>
          <br />
          <br />
          <i>Ratakilometrien laskenta copyright (c) 2018 P. Touru</i>
        </Typography>



      </Drawer>

      <Tutorial startTutorial={startTutorial} setStartTutorial={setStartTutorial} setDrawerOpen={setDrawerOpen} />

      <Container maxWidth={false} sx={{ padding: 0 }}>
        <Routes>
          <Route path="/" element={<Ajot token={token} kayttajaId={kayttajaId} setSuurinJarjestysNum={setSuurinJarjestysNum} />} />
          <Route path="/login" element={<Login setToken={setToken} setKayttajaId={setKayttajaId} />} />
          <Route path="/kirjaa" element={<Kirjaa token={token} kayttajaId={kayttajaId} suurinJarjestysNum={suurinJarjestysNum} setSuurinJarjestysNum={setSuurinJarjestysNum} />} />
          <Route path="/asetukset" element={<Asetukset token={token} kayttajaId={kayttajaId} />} />
          <Route path="/tilastot" element={<Tilastot token={token} kayttajaId={kayttajaId} />} />
          <Route path="/ohjeet" element={<Ohjeet token={token} kayttajaId={kayttajaId} />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
};

export default App;
